import { useEffect, useState } from 'react';
import axios from 'axios';
import endpoints from '../define/endpoints';
import { camelizeKeys } from 'humps';

export function useListing(listingId) {
  const [listing, setListing] = useState(null);
  useEffect(() => {
    (async function () {
      if (listingId) {
        const { data } = await axios.get(
          `${endpoints.core}/listings/${listingId}`, {
            params: { locale: window.freedomeConfig.locale }
          }
        );
        setListing(camelizeKeys(data));
      }
    })();
  }, [listingId]);
  return listing;
}
